__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/1aa7a55/_next/";